import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';

import { EchartCardComponent, EChartCardConfig }   from '../../echart-card/echart-card.component';
import { ChartjsCardComponent, ChartJsCardConfig } from '../../chartjs-card/chartjs-card.component';

// ── Datos de demostración ─────────────────────────────────────────────────────
const MONTHS  = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
const ACTUAL  = [42, 58, 35, 74, 61, 89, 53, 67, 48, 82, 71, 95];
const TARGET  = [50, 60, 50, 70, 65, 80, 60, 70, 55, 85, 75, 90];

const MONTHLY = MONTHS.map((mes, i) => ({
  mes,
  ventas:   ACTUAL[i],
  objetivo: TARGET[i],
  pct:      `${+(ACTUAL[i] / TARGET[i] * 100).toFixed(1)} %`,
}));

const CATS     = ['Alfa','Beta','Gamma','Delta','Épsilon','Zeta','Eta','Theta'];
const CAT_VALS = [85, 72, 63, 91, 44, 78, 56, 88];
const CAT_OBJ  = [90, 80, 70, 95, 50, 85, 65, 90];

const CAT_DATA = CATS.map((cat, i) => ({
  cat,
  valor:    CAT_VALS[i],
  objetivo: CAT_OBJ[i],
  Porcentaje_CUMP: `${+(CAT_VALS[i] / CAT_OBJ[i] * 100).toFixed(1)} %`,
}));

const GAUGE_DATA = [{ label: 'Cumplimiento', Porcentaje_CUMP: '76.4 %' }];

// ─────────────────────────────────────────────────────────────────────────────

@Component({
  selector: 'app-chart-gallery',
  standalone: true,
  imports: [
    CommonModule,
    MatTabsModule,
    EchartCardComponent,
    ChartjsCardComponent,
  ],
  templateUrl: './chart-gallery.component.html',
  styleUrl:    './chart-gallery.component.scss',
})
export class ChartGalleryComponent {

  // ── ECharts — 8 tipos ────────────────────────────────────────────────────
  echartCards: EChartCardConfig[] = [
    {
      title: 'Barras + Línea %',
      chartType: 'ec_bar', labelKey: 'cat',
      valueKey: 'valor', value2Key: 'objetivo',
      data: CAT_DATA,
    },
    {
      title: 'Línea suavizada',
      chartType: 'ec_line', labelKey: 'mes', valueKey: 'ventas',
      data: MONTHLY,
    },
    {
      title: 'Rose / Nightingale',
      chartType: 'ec_rose', labelKey: 'cat', valueKey: 'valor',
      data: CAT_DATA,
    },
    {
      title: 'Gauge',
      chartType: 'ec_gauge', valueKey: 'Porcentaje_CUMP',
      data: GAUGE_DATA,
    },
    {
      title: 'Radar — Top categorías',
      chartType: 'ec_radar', labelKey: 'cat', valueKey: 'valor',
      data: CAT_DATA,
    },
    {
      title: 'Funnel',
      chartType: 'ec_funnel', labelKey: 'cat', valueKey: 'valor',
      data: CAT_DATA,
    },
    {
      title: 'Treemap',
      chartType: 'ec_treemap', labelKey: 'cat', valueKey: 'valor',
      data: CAT_DATA,
    },
    {
      title: 'Dispersión',
      chartType: 'ec_scatter', labelKey: 'cat',
      valueKey: 'objetivo', value2Key: 'valor',
      data: CAT_DATA,
    },
  ];

  // ── Chart.js — 12 tipos ──────────────────────────────────────────────────
  cjCards: ChartJsCardConfig[] = [
    {
      title: 'Combo — Barras + Línea %',
      chartType: 'cj_combo', labelKey: 'cat',
      valueKey: 'valor', value2Key: 'objetivo',
      data: CAT_DATA,
    },
    {
      title: 'Barras verticales',
      chartType: 'cj_bar', labelKey: 'cat',
      valueKey: 'valor', value2Key: 'objetivo',
      data: CAT_DATA,
    },
    {
      title: 'Barras horizontales',
      chartType: 'cj_bar_h', labelKey: 'cat',
      valueKey: 'valor', value2Key: 'objetivo',
      data: CAT_DATA,
    },
    {
      title: 'Barras apiladas',
      chartType: 'cj_stacked', labelKey: 'cat',
      valueKey: 'valor', value2Key: 'objetivo',
      data: CAT_DATA,
    },
    {
      title: 'Línea',
      chartType: 'cj_line', labelKey: 'mes', valueKey: 'ventas',
      data: MONTHLY,
    },
    {
      title: 'Área multi-serie',
      chartType: 'cj_area', labelKey: 'cat',
      valueKey: 'valor', value2Key: 'objetivo',
      data: CAT_DATA,
    },
    {
      title: 'Donut',
      chartType: 'cj_donut', labelKey: 'cat', valueKey: 'valor',
      data: CAT_DATA,
    },
    {
      title: 'Pie',
      chartType: 'cj_pie', labelKey: 'cat', valueKey: 'valor',
      data: CAT_DATA,
    },
    {
      title: 'Radar',
      chartType: 'cj_radar', labelKey: 'cat', valueKey: 'valor',
      data: CAT_DATA,
    },
    {
      title: 'Polar area',
      chartType: 'cj_polar', labelKey: 'cat', valueKey: 'valor',
      data: CAT_DATA,
    },
    {
      title: 'Burbuja — valor vs objetivo',
      chartType: 'cj_bubble', labelKey: 'cat',
      valueKey: 'valor', value2Key: 'objetivo',
      data: CAT_DATA,
    },
    {
      title: 'Dispersión',
      chartType: 'cj_scatter', labelKey: 'cat',
      valueKey: 'objetivo', value2Key: 'valor',
      data: CAT_DATA,
    },
  ];
}
